import {
    EQUIPMENT_TYPES_LOAD_BEGIN,
    EQUIPMENT_TYPES_LOAD_END,
    EQUIPMENT_TYPES_LOAD_ERROR,
    FETCH_EQUIPMENT_TYPES
} from '../actions/actionTypes';

const initialState = {
    data:    [],
    error:   null,
    loading: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_EQUIPMENT_TYPES:
            return {
                ...state,
                data: action.payload
            };
        case EQUIPMENT_TYPES_LOAD_BEGIN:
            return {
                ...state,
                error:   initialState.error,
                loading: true
            };
        case EQUIPMENT_TYPES_LOAD_END:
            return {
                ...state,
                loading: false
            };
        case EQUIPMENT_TYPES_LOAD_ERROR:
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
};
